import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/preChatActivity/PreChatMessageActivity.module_built.css";
const classes = {"pre-chat-message-activity__body":"wdPvBTa_pre-chat-message-activity__body","pre-chat-message-activity__body--blueprint":"wdPvBTa_pre-chat-message-activity__body--blueprint","pre-chat-message-activity__body-avatar":"wdPvBTa_pre-chat-message-activity__body-avatar","pre-chat-message-activity__body-title":"wdPvBTa_pre-chat-message-activity__body-title","pre-chat-message-activity":"wdPvBTa_pre-chat-message-activity","pre-chat-message-activity__toolbar":"wdPvBTa_pre-chat-message-activity__toolbar","pre-chat-message-activity__body-subtitle":"wdPvBTa_pre-chat-message-activity__body-subtitle"}
export default classes

const _pre_chat_message_activity__body0 = classes["pre-chat-message-activity__body"]
export { _pre_chat_message_activity__body0 as "pre-chat-message-activity__body" }

const _pre_chat_message_activity__body__blueprint0 = classes["pre-chat-message-activity__body--blueprint"]
export { _pre_chat_message_activity__body__blueprint0 as "pre-chat-message-activity__body--blueprint" }

const _pre_chat_message_activity__body_avatar0 = classes["pre-chat-message-activity__body-avatar"]
export { _pre_chat_message_activity__body_avatar0 as "pre-chat-message-activity__body-avatar" }

const _pre_chat_message_activity__body_title0 = classes["pre-chat-message-activity__body-title"]
export { _pre_chat_message_activity__body_title0 as "pre-chat-message-activity__body-title" }

const _pre_chat_message_activity0 = classes["pre-chat-message-activity"]
export { _pre_chat_message_activity0 as "pre-chat-message-activity" }

const _pre_chat_message_activity__toolbar0 = classes["pre-chat-message-activity__toolbar"]
export { _pre_chat_message_activity__toolbar0 as "pre-chat-message-activity__toolbar" }

const _pre_chat_message_activity__body_subtitle0 = classes["pre-chat-message-activity__body-subtitle"]
export { _pre_chat_message_activity__body_subtitle0 as "pre-chat-message-activity__body-subtitle" }
